module.exports = __webpack_public_path__ + "img/think-sky-img.c43533be.png";